export const SEOSchema = () => {
  const organizationSchema = {
    "@context": "https://schema.org",
    "@type": "AccountingService",
    "name": "KGOB CPAs & Advisors",
    "alternateName": "Kohari Gonzalez Oneyear & Brown",
    "legalName": "Kohari Gonzalez Oneyear & Brown PLLC",
    "description": "Full-service CPA firm offering tax preparation, tax planning, IRS resolution, bookkeeping, payroll, business advisory, and entity formation services. Let's Talk Growth.",
    "url": "https://kgob.com",
    "logo": "https://kgob.com/brand/kgob-logo.png",
    "image": "https://kgob.com/brand/kgob-logo.png",
    "telephone": "+1-844-599-3355",
    "email": "connect@kgob.com",
    "foundingDate": "1988",
    "slogan": "Let's Talk Growth",
    "priceRange": "$$$",
    "address": {
      "@type": "PostalAddress",
      "streetAddress": "2740 East WT Harris Blvd, Suite 200",
      "addressLocality": "Charlotte",
      "addressRegion": "NC",
      "postalCode": "28213",
      "addressCountry": "US"
    },
    "geo": {
      "@type": "GeoCoordinates",
      "latitude": 35.2775429,
      "longitude": -80.7276954
    },
    "hasMap": "https://maps.app.goo.gl/ivNjbD5tGZ1J8YW4A",
    "openingHoursSpecification": [
      {
        "@type": "OpeningHoursSpecification",
        "dayOfWeek": ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday"],
        "opens": "09:00",
        "closes": "18:00"
      },
      {
        "@type": "OpeningHoursSpecification",
        "dayOfWeek": "Saturday",
        "opens": "10:00",
        "closes": "14:00"
      }
    ],
    "areaServed": [
      { "@type": "Country", "name": "United States" },
      { "@type": "State", "name": "North Carolina" },
      { "@type": "State", "name": "South Carolina" }
    ],
    "sameAs": [
      "https://www.linkedin.com/company/kgobcpa/",
      "https://www.instagram.com/kgobcpa",
      "https://x.com/kgobcpa"
    ],
    "hasOfferCatalog": {
      "@type": "OfferCatalog",
      "name": "CPA Services",
      "itemListElement": [
        {
          "@type": "Offer",
          "itemOffered": {
            "@type": "Service",
            "name": "Tax Preparation & Planning",
            "description": "Individual, business, trust, and estate tax preparation with proactive tax planning strategies",
            "url": "https://kgob.com/services/tax"
          }
        },
        {
          "@type": "Offer",
          "itemOffered": {
            "@type": "Service",
            "name": "IRS Account Review & Tax Resolution",
            "description": "IRS notice resolution, transcript analysis, payment plans, offers in compromise, and audit representation",
            "url": "https://kgob.com/irs-account-review"
          }
        },
        {
          "@type": "Offer",
          "itemOffered": {
            "@type": "Service",
            "name": "Accounting & Payroll",
            "description": "Bookkeeping, payroll processing, financial statements, and catch-up accounting services",
            "url": "https://kgob.com/services/accounting-payroll"
          }
        },
        {
          "@type": "Offer",
          "itemOffered": {
            "@type": "Service",
            "name": "Business Advisory & Consulting",
            "description": "Fractional CFO services, business advisory, financial planning, and growth strategy",
            "url": "https://kgob.com/services/consulting"
          }
        },
        {
          "@type": "Offer",
          "itemOffered": {
            "@type": "Service",
            "name": "Entity Formation & Restructuring",
            "description": "LLC, S-Corp, C-Corp formation and entity restructuring for optimal tax efficiency",
            "url": "https://kgob.com/services/entity"
          }
        },
        {
          "@type": "Offer",
          "itemOffered": {
            "@type": "Service",
            "name": "Business Valuation",
            "description": "Business valuation for sales, acquisitions, partner buyouts, and estate planning",
            "url": "https://kgob.com/services/valuation"
          }
        }
      ]
    },
    "knowsAbout": [
      "Tax Preparation",
      "Tax Planning",
      "IRS Resolution",
      "Tax Relief",
      "Bookkeeping",
      "Payroll",
      "Business Advisory",
      "CFO Services",
      "Entity Formation",
      "S-Corp Election",
      "Business Valuation",
      "Trust Taxation",
      "Estate Tax",
      "Nonprofit Accounting"
    ]
  };

  const faqSchema = {
    "@context": "https://schema.org",
    "@type": "FAQPage",
    "mainEntity": [
      {
        "@type": "Question",
        "name": "What services does KGOB provide?",
        "acceptedAnswer": {
          "@type": "Answer",
          "text": "KGOB provides comprehensive CPA services including tax preparation and planning, IRS account review and tax resolution, bookkeeping and payroll, business advisory and fractional CFO services, entity formation and restructuring (LLC, S-Corp, C-Corp), and business valuation. We serve individuals, businesses, trusts, and estates across all 50 states."
        }
      },
      {
        "@type": "Question",
        "name": "Where is KGOB located?",
        "acceptedAnswer": {
          "@type": "Answer",
          "text": "KGOB has four offices in North Carolina: the Charlotte HQ at 2740 East WT Harris Blvd, the SouthPark satellite at 6000 Fairview Road (by appointment), the Winston-Salem office at 326 S. Main Street, and the Mooresville office at 121 Rolling Hill Road (by appointment). While our physical offices are in North Carolina, we serve individual and business clients across all 50 states through our secure online portal. Tax preparation, planning, IRS representation, and advisory services are all available remotely."
        }
      },
      {
        "@type": "Question",
        "name": "What makes KGOB different from other CPA firms?",
        "acceptedAnswer": {
          "@type": "Answer",
          "text": "KGOB is a full-service CPA firm that combines Luxury Advisory with Precision Compliance. We handle complex situations including multi-entity structures, IRS issues, and catch-up work. With 35+ years of experience, licensed CPAs, a modern client portal, and proactive year-round tax planning, we build long-term partnerships rooted in trust and measurable results."
        }
      },
      {
        "@type": "Question",
        "name": "Can KGOB help with IRS notices and tax problems?",
        "acceptedAnswer": {
          "@type": "Answer",
          "text": "Yes. KGOB has a dedicated IRS resolution team that handles notice response, penalty abatement, installment agreements, Offers in Compromise, audit defense, lien removal, and Currently Not Collectible status. Start with an IRS Account Review at kgob.com/irs-account-review to get a clear picture of your IRS standing."
        }
      }
    ]
  };

  return (
    <>
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(organizationSchema) }}
      />
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(faqSchema) }}
      />
    </>
  );
};
